/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Product } from './Product';
import {
    ProductFromJSON,
    ProductFromJSONTyped,
    ProductToJSON,
} from './Product';
import type { Sale } from './Sale';
import {
    SaleFromJSON,
    SaleFromJSONTyped,
    SaleToJSON,
} from './Sale';

/**
 * 
 * @export
 * @interface GetSaleProducts200ResponseAllOfData
 */
export interface GetSaleProducts200ResponseAllOfData {
    /**
     * 
     * @type {Sale}
     * @memberof GetSaleProducts200ResponseAllOfData
     */
    sale: Sale;
    /**
     * 
     * @type {Array<Product>}
     * @memberof GetSaleProducts200ResponseAllOfData
     */
    products: Array<Product>;
}

/**
 * Check if a given object implements the GetSaleProducts200ResponseAllOfData interface.
 */
export function instanceOfGetSaleProducts200ResponseAllOfData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sale" in value;
    isInstance = isInstance && "products" in value;

    return isInstance;
}

export function GetSaleProducts200ResponseAllOfDataFromJSON(json: any): GetSaleProducts200ResponseAllOfData {
    return GetSaleProducts200ResponseAllOfDataFromJSONTyped(json, false);
}

export function GetSaleProducts200ResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSaleProducts200ResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sale': SaleFromJSON(json['sale']),
        'products': ((json['products'] as Array<any>).map(ProductFromJSON)),
    };
}

export function GetSaleProducts200ResponseAllOfDataToJSON(value?: GetSaleProducts200ResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sale': SaleToJSON(value.sale),
        'products': ((value.products as Array<any>).map(ProductToJSON)),
    };
}

